import axiosInstance from '@/core/api'
import {
	BrokeFlexMessageCampaignResponse,
	BrokeFlexMessageCampaignListResponse,
	BrokeFlexMessageCampaignModel,
	CreateBrokeFlexMessageCampaignRequest,
	UpdateBrokeFlexMessageCampaignRequest,
} from '../../types'

class BrokeFlexMessageService {
	// Get all campaigns
	async getCampaigns(
		isActive?: boolean,
	): Promise<BrokeFlexMessageCampaignListResponse> {
		const response =
			await axiosInstance.get<BrokeFlexMessageCampaignListResponse>(
				'/admin/broke-flex-messages/campaigns',
				{ params: { isActive } },
			)
		return response.data
	}

	// Get single campaign
	async getCampaign(id: string): Promise<BrokeFlexMessageCampaignModel> {
		const response = await axiosInstance.get<BrokeFlexMessageCampaignResponse>(
			`/admin/broke-flex-messages/campaigns/${id}`,
		)
		return response.data.data
	}

	// Create campaign
	async createCampaign(data: CreateBrokeFlexMessageCampaignRequest) {
		const response = await axiosInstance.post<BrokeFlexMessageCampaignResponse>(
			'/admin/broke-flex-messages/campaigns',
			data,
		)
		return response.data
	}

	// Update campaign
	async updateCampaign(
		id: string,
		data: UpdateBrokeFlexMessageCampaignRequest,
	) {
		const response = await axiosInstance.put<BrokeFlexMessageCampaignResponse>(
			`/admin/broke-flex-messages/campaigns/${id}`,
			data,
		)
		return response.data
	}

	// Delete campaign
	async deleteCampaign(id: string) {
		const response = await axiosInstance.delete(
			`/admin/broke-flex-messages/campaigns/${id}`,
		)
		return response.data
	}

	// Preview stage
	async previewStage(campaignId: string, stageId: string) {
		const response = await axiosInstance.post(
			`/admin/broke-flex-messages/campaigns/${campaignId}/preview/${stageId}`,
		)
		return response.data
	}
}

export default new BrokeFlexMessageService()
